import PermissionChecker from 'src/modules/auth/permissionChecker'
import { Navigate } from 'react-router-dom'
import LayoutPublic from 'src/view/layout/LayoutPublic'

function PublicRoute({ component, currentUser, ...rest }) {
  const permissionChecker = new PermissionChecker(currentUser)

  if (permissionChecker.isAuthenticated && !rest.allowsAuthenticatedUsers) {
    return <Navigate to="/" />
  }

  return <LayoutPublic>{component}</LayoutPublic>
  //return <Layout>{component}</Layout>
}

export default PublicRoute
